export enum UnitType {
  Pieces,
  Multipack,
  Pallet,
}
